<div class="confirm-dialog-container">
  <h2 mat-dialog-title>{{ title }}</h2>

  <mat-dialog-content class="content-container">
    <span class="content-message">{{ data.message }}</span>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">{{ cancelLabel }}</button>
    <button mat-raised-button [color]="confirmColor" (click)="confirm()">
      {{ confirmLabel }}
    </button>
  </mat-dialog-actions>
</div>